import React, { useMemo } from 'react';
import StyledBox, {
  StyledBenefitItem,
} from 'views/membership-module/MembershipView/components/HeroImgSection/HeroImgSection.styles';
import {
  Box, Container, Typography, Button,
} from '@mui/material';
import { ImgBox, Typography700 } from 'views/common/components';
import CheckIcon from '@mui/icons-material/Check';

import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { useTranslation } from 'next-i18next';

const HeroImgSection = (props) => {
  const { t } = useTranslation('fe_er_membership_page');
  const { membershipData, getSubscribeNowPath } = props;
  const benefitList = useMemo(
    () => [
      t('fe_er_membership_page:benfite_days', {
        count: membershipData.rental_credits_count,
      }),
      t('fe_er_membership_page:benfite_months', { count: 18 }),
      t('fe_er_membership_page:benfite_locations', { count: 100 }),
      t('fe_er_membership_page:benfite_share'),
    ],
    [membershipData.rental_credits_count],
  );
  return (
    <StyledBox>
      <Box className="HISWrapper">
        <Box className="HISBG">
          <ImgBox
            imgWidth="100%"
            imgHeight="100%"
            imgObjectFit="contain"
            image={{
              src: '/imgs/heroimg.png',
              alt: t('fe_er_membership_landing_page:join_club_eagleRider'),
            }}
          />
        </Box>
        <Container maxWidth="xl" className="RTVContainer">
          <Box className="HISDetails">
            <Typography700 variant="h1" component="p" className="HISTitle">
              {t('fe_er_membership_page:hero_section_title')}
            </Typography700>
            <Typography variant="h5" className="HISSubTitle">
              {t('fe_er_membership_page:hero_section_subtitle')}
            </Typography>
            <Box className="HISPriceBox">
              <Box className="HISPricAndSub">
                <Typography className="HISPricePerMonth">
                  <Typography700 component="span" className="HISPrice">
                    {membershipData.monthly_price}
                    <Typography700 component="span" className="HISPriceStar">
                      *
                    </Typography700>
                  </Typography700>
                  /
                  {t('fe_er_membership_page:month')}
                </Typography>
                <Box className="HISSubBtnContainer">
                  <Button
                    href={getSubscribeNowPath()}
                    variant="text"
                    className="HISSubBtn"
                    component={NavigatorLink}>
                    {t('fe_er_membership_page:subscribe_now')}
                  </Button>
                </Box>
              </Box>
              {benefitList.map((item) => (
                <Box className="HISBenfitItem" key={item}>
                  <StyledBenefitItem
                    icon={<CheckIcon className="HISCheckIcon" />}
                    text={item}
                  />
                </Box>
              ))}
            </Box>
            <Typography variant="caption" className="HISNote" component="p">
              {t('fe_er_membership_page:price_excludes_insurance', {
                count: membershipData.term_months,
              })}
            </Typography>
          </Box>
        </Container>
      </Box>
    </StyledBox>
  );
};

export { HeroImgSection };
